<div class="control product-chooser" [ngSwitch]="displayStyle">
  <mat-form-field *ngSwitchCase="'DropDown'" [style.width]="'100%'">
    <mat-select [(ngModel)]="selectedValue"
                panelClass="pap-mat-primary pc-overlay"
               (change)="setCurrentProduct($event.value)"
               #productChooser
               >
      <mat-select-trigger *ngIf="selectedValue">
        <div class="option-name-price"
             [ngClass]="{'disabled': !selectedValue.inStock}">
          <span class="name" *ngIf="!selectedValue.iconURL">
            {{ selectedValue.shortName }}
          </span>
          <span class="name" *ngIf="selectedValue.iconURL">
            {{ selectedValue.extraShortName }}
            <img class="icon" src="{{ selectedValue.iconURL }}">
          </span>
          <span class="price">
            <price-display [price]="selectedValue.price"
                           [quantity]="1">
            </price-display>
          </span>
        </div>
      </mat-select-trigger>
      <div class="product-chooser-title">
         {{ 'i18n.toolbox.productChooser.title' | translate }}
      </div>
      <mat-option [ngClass]='["product-chooser-option"]'
                  *ngFor="let option of options; trackBy: trackById"
                  [value]="option"
                  [disabled]="!option.inStock">
        <div class="option-name-price overlay"
             [ngClass]="{'disabled': !option.inStock}">
          <span class="name" *ngIf="!option.iconURL">
            {{ option.shortName }}
          </span>
          <span class="name" *ngIf="option.iconURL">
            {{ option.extraShortName }}
            <img class="icon" src="{{ option.iconURL }}">
          </span>
          <span class="price">
            <price-display [price]="option.price"
                           [quantity]="1">
            </price-display>
          </span>
        </div>
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>



// WEBPACK FOOTER //
// ./src/app/controls/product-chooser/product-chooser.component.html